module.exports = __webpack_public_path__ + "static/media/plane.95329065.gif";